module.exports = __webpack_public_path__ + "img/sp.86285b39.png";